import {
  RECORDING_REFERRAL_INFO_FAILED,
  RECORDING_REFERRAL_INFO_SUCCEEDED,
  RECORDING_REFERRAL_INFO,
} from "../actions/actionTypes";

import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import { takeEvery, call, put } from "redux-saga/effects";
import { RecordReferralInfoErrorResponse, RecordReferralInfoRequest, RecordReferralInfoResponse } from "src/types/referralInfo";

const apiUrl = process.env.REACT_APP_API_URL;
const REFERRAL_BASE_URL = `${apiUrl}/api/2.0/users/referral`;

export const recordReferralInfo = createAction<RecordReferralInfoRequest>(RECORDING_REFERRAL_INFO);
const recordingReferralInfoSucceeded = createAction<RecordReferralInfoResponse>(
  RECORDING_REFERRAL_INFO_SUCCEEDED,
);
const recordingReferralInfoFailed = createAction<RecordReferralInfoErrorResponse>(
  RECORDING_REFERRAL_INFO_FAILED,
);

const recordReferralInfoSaga = function* (
  action: ReturnType<typeof recordReferralInfo>,
): any {
  const { referralData } = action.payload as RecordReferralInfoRequest;

  const recordReferralInfoSagaAPI = () => {
    return axios({
      method: "POST",
      url: REFERRAL_BASE_URL,
      data: referralData,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(recordReferralInfoSagaAPI);
    yield put(recordingReferralInfoSucceeded(response));
  } catch (error) {
    yield put(recordingReferralInfoFailed({ error }));
  }
};

export default function* referralInfoSaga() {
  yield takeEvery(RECORDING_REFERRAL_INFO, recordReferralInfoSaga);
}
